'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import posthog from 'posthog-js'
import { useEffect } from 'react'
// oxlint-disable-next-line @qogita/no-deprecated-imports -- intentional bridge for legacy pages router
import { useUserContext } from 'src/deprecated/contexts/User'

import { posthogConfig } from './config'

/**
 * Pages-router PostHog user identification via `UserProvider` / `useUserContext()`
 * (same source as the rest of the legacy app: React Query `userQueries.detail()`).
 * Render inside `UserProvider` (e.g. from `pages/_app.tsx`).
 */
export function IdentifyPosthogUserPagesRouter() {
  const user = useUserContext()

  useEffect(() => {
    if (!posthogConfig.enabled) return

    if (user?.qid) {
      posthog.identify(user.qid, { email: user.email })
      if (!posthog.has_opted_in_capturing()) {
        posthog.opt_in_capturing()
      }
      posthog.startSessionRecording()
    } else {
      posthog.opt_out_capturing()
      posthog.stopSessionRecording()
      posthog.reset()
    }
  }, [user?.qid, user?.email])

  return null
}
